import { useApiPatch } from 'mf_core/query';
import { useMutation } from '@tanstack/react-query';

export function usePreferredLanguageMutation(language: string) {
  const apiPatch = useApiPatch();
  const body = { language };

  return useMutation({
    mutationFn: () => {
      const data = apiPatch(
        `/account-management/v1/users/preferred-language`,
        body
      );

      return data;
    },
  });
}
